'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/Button/index.js');
var noChats = require('../../../images/no-chats.png.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var BlankSlate = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(BlankSlate, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(BlankSlate);

  function BlankSlate() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, BlankSlate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleSelect", function () {
      _this.props.onSelect();
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(BlankSlate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          buttonLabel = _this$props.buttonLabel,
          explanation = _this$props.explanation,
          imageRoute = _this$props.imageRoute,
          onSelect = _this$props.onSelect;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-blank-slate ".concat(this.props.className)
      }, this.props.imageRoute === 'empty' ? /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-blank-slate-background-image"
      }) : /*#__PURE__*/React__default['default'].createElement("img", {
        className: "ds-org-blank-slate-image-container",
        alt: "default blank slate",
        src: imageRoute
      }), /*#__PURE__*/React__default['default'].createElement("h3", {
        className: "ds-org-blank-slate-header"
      }, title), /*#__PURE__*/React__default['default'].createElement("p", {
        className: "ds-org-blank-slate-paragraph"
      }, explanation), onSelect && /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-atom-btn-small-primary-normal ds-org-blank-slate-cta",
        onSelect: this.handleSelect
      }, buttonLabel));
    }
  }]);

  return BlankSlate;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(BlankSlate, "propTypes", {
  onSelect: PropTypes__default['default'].func,
  className: PropTypes__default['default'].string,
  explanation: PropTypes__default['default'].string,
  imageRoute: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string,
  buttonLabel: PropTypes__default['default'].string
});

_rollupPluginBabelHelpers.defineProperty(BlankSlate, "defaultProps", {
  onSelect: null,
  buttonLabel: 'Click here',
  className: '',
  explanation: '',
  imageRoute: noChats,
  title: ''
});

module.exports = BlankSlate;
